var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-page"},[_c('iframe',{staticClass:"terms-frame",attrs:{"src":_vm.termsUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }